var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "form",
    {
      ref: "changePasswordForm",
      attrs: { action: _vm.passwordResetUrl, method: "post" },
      on: {
        submit: function ($event) {
          $event.preventDefault()
        },
      },
    },
    [
      _vm._t("csrf"),
      _vm._v(" "),
      _vm._t("input-next"),
      _vm._v(" "),
      _c("div", { staticClass: "form-row" }, [
        _c("div", { staticClass: "form-group col" }, [
          _c("label", { staticClass: "control-label" }, [
            _vm._v(_vm._s(_vm.i18n.password)),
          ]),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model.trim",
                value: _vm.password,
                expression: "password",
                modifiers: { trim: true },
              },
            ],
            staticClass: "form-control",
            class: _vm.passwordError ? "is-invalid" : "",
            attrs: {
              name: "password",
              autocomplete: "new-password",
              type: _vm.isPasswordVisible ? "text" : "password",
              placeholder: _vm.i18n.password,
            },
            domProps: { value: _vm.password },
            on: {
              input: function ($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.password = $event.target.value.trim()
              },
              blur: function ($event) {
                return _vm.$forceUpdate()
              },
            },
          }),
          _vm._v(" "),
          _c("span", {
            staticClass: "fa fa-fw field-icon toggle-password",
            class: _vm.isPasswordVisible ? "fa-eye" : "fa-eye-slash",
            on: { click: _vm.onEyeClick },
          }),
          _vm._v(" "),
          _vm.passwordError
            ? _c("div", { staticClass: "invalid-feedback" }, [
                _vm._v(
                  "\n                " +
                    _vm._s(_vm.passwordError) +
                    "\n            "
                ),
              ])
            : _vm._e(),
        ]),
      ]),
      _vm._v(" "),
      _c("div", [
        _c("div", { staticClass: "progress" }, [
          _c("div", {
            staticClass: "progress-bar",
            class: _vm.progressStatus.progressClass,
          }),
        ]),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "signup-password-info", attrs: { id: "message" } },
        [
          _c("h6", [
            _vm._v("\n        " + _vm._s(_vm.i18n.mustHave) + "\n      "),
          ]),
          _vm._v(" "),
          _c("ul", [
            _c("li", {
              class: _vm.progressStatus.lower ? "valid" : "invalid",
              domProps: { innerHTML: _vm._s(_vm.i18n.lowercase) },
            }),
            _vm._v(" "),
            _c("li", {
              class: _vm.progressStatus.upper ? "valid" : "invalid",
              domProps: { innerHTML: _vm._s(_vm.i18n.uppercase) },
            }),
            _vm._v(" "),
            _c("li", {
              class: _vm.progressStatus.number ? "valid" : "invalid",
              domProps: { innerHTML: _vm._s(_vm.i18n.number) },
            }),
            _vm._v(" "),
            _c("li", {
              class: _vm.progressStatus.length ? "valid" : "invalid",
              domProps: { innerHTML: _vm._s(_vm.i18n.minCharacters) },
            }),
          ]),
        ]
      ),
      _vm._v(" "),
      _vm.generalError
        ? _c("ui-alert", { attrs: { type: "error", title: _vm.generalError } })
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "form-row" }, [
        _c(
          "div",
          { staticClass: "form-group col" },
          [
            _vm.captchaType === "turnstile"
              ? _c("turnstile", {
                  class: {
                    "border-error error-anchor": !_vm.isRecaptchaFilled,
                  },
                  attrs: {
                    sitekey: _vm.newCaptchaSiteKey,
                    language: _vm.language,
                  },
                })
              : _vm.captchaType === "hcaptcha"
              ? _c("hcaptcha", {
                  class: { "border-error": !_vm.isRecaptchaFilled },
                  attrs: {
                    sitekey: _vm.newCaptchaSiteKey,
                    language: _vm.language,
                  },
                })
              : _c("recaptcha", {
                  class: { "border-error": !_vm.isRecaptchaFilled },
                  attrs: {
                    sitekey: _vm.captchaSiteKey,
                    language: _vm.language,
                  },
                }),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("ui-button", {
        attrs: {
          block: "",
          uppercase: "",
          appearance: "primary",
          disabled: !_vm.isRecaptchaReady || _vm.submittedForm,
          label: _vm.i18n.savePassword,
        },
        on: { click: _vm.validate },
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }